<template lang="pug">
  Wrapper.q-px-lg.q-py-xl
    h5.q-mb-xl Statistics - Summary Report
    .filter.q-mb-md.bg-gray.flex.justify-between
      .container-fluid.overflow-auto
        .row.items-center.q-col-gutter-md
          .col-lg-6.col-xl-4
            md-datepicker(v-model="from" md-immediately)
              label From (Date Issued)
          .col-lg-6.col-xl-4
            md-datepicker(v-model="to" md-immediately)
              label To (Date Issued)
    .export.q-mb-md.bg-gray
      .container-fluid.overflow-auto
        .row.q-col-gutter-md
          .col-lg-6.col-xl-4
            md-field
              label Account / Company
              md-input(v-model="search")
              md-icon.md-primary search
          .col-lg-6.col-xl-4
            md-field
                label Sort:
                md-select(v-model="sort")
                  md-option(value="newest") Newest
          .finder.col-lg-4.offset-lg-8.offset-xl-0
            span.flex.items-center
              md-icon.icon print
              span.q-mr-md.icon-label Print
            span.flex.items-center
              md-icon.icon keyboard_capslock
              span.q-mr-md.icon-label Export
    .q-mb-md.content-wrapper
      .summary-info.q-pa-md
        h5 Monthly Summary
        p 1234 Logistics Co.,Ltd.
        p.text-muted Date: 23 / 11 / 2016 - 14 / 12 / 2016
      .container-fluid.q-px-none
        .row.summary-data
          .col-3.q-pa-none
            p.q-ma-none.q-pa-md.table-header.monthly-summary Monthly Summary
            p.q-ma-none.q-pa-md.table-header Total RFQ Received
            p.q-ma-none.q-pa-md.table-header Total Qoutes Sent
            p.q-ma-none.q-pa-md.table-header Number Of Bookings Received
            p.q-ma-none.q-pa-md.table-header Value Of Bookings Received ($)
          .col.q-pa-none.data-cell(v-for="summary in summaries" :key="summary.date")
            p.q-ma-none.q-pa-md {{ summary.date }}
            p.q-ma-none.q-pa-md {{ summary.rfqReceived }}
            p.q-ma-none.q-pa-md {{ summary.quoteSent }}
            p.q-ma-none.q-pa-md {{ summary.bookingReceived }}
            p.q-ma-none.q-pa-md {{ summary.totalValues }}
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import formatDateMixin from '@/utils/mixins/formatDateMixin';

const fake = [
  {
    date: '2016-08',
    rfqReceived: 20,
    quoteSent: 10,
    bookingReceived: 0,
    totalValues: 1000,
  },
  {
    date: '2016-09',
    rfqReceived: 15,
    quoteSent: 5,
    bookingReceived: 0,
    totalValues: 800,
  },
  {
    date: '2016-10',
    rfqReceived: 35,
    quoteSent: 10,
    bookingReceived: 0,
    totalValues: 900,
  },
  {
    date: '2016-11',
    rfqReceived: 28,
    quoteSent: 5,
    bookingReceived: 0,
    totalValues: 700,
  },
];

export default {
  name: 'AdminRFQ',

  components: {
    Wrapper,
  },

  mixins: [formatDateMixin],

  data() {
    return {
      currentPage: 1,
      pageLimit: 10,
      search: '',
      from: null,
      to: null,
      sort: 'newest',
      summaries: [],
    };
  },

  mounted() {
    // eslint-disable-next-line
    for (let i = 0; i < fake.length; i++) {
      this.summaries.push(fake[i]);
    }
  },
};
</script>

<style lang="scss" scoped>
$main: #24a0ff;

.icon-label {
  color: $main;
  cursor: pointer;
  font-size: 14px;
}

.icon {
  color: $main !important;
  font-size: 18px !important;
}

.cta {
  display: flex;
  margin-bottom: 1rem;

  @media screen and (min-width: 75em) {
    margin-bottom: 0;
  }
}

.finder {
  display: flex;
  margin-bottom: 1rem;
  justify-content: center;

  @media screen and (min-width: 75em) {
    justify-content: flex-start;
    margin-bottom: 0;
  }
}

.summary-info {
  background-color: #dedede;
}

.content-wrapper {
  overflow: hidden;
  border: 1px solid #dedede;
  border-radius: 4px;
}

.summary-data {
  background-color: #f6f8f9;
}

.table-header {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  font-size: 12px;
}

.monthly-summary {
  background-color: #f1f2f3;
}

.data-cell {
  border-left: 2px solid rgba(0, 0, 0, 0.025);

  &:nth-of-type(even) {
    > p:first-child {
      background-color: #eaeaea;
    }
  }

  > p:first-child {
    background-color: #f1f2f3;
  }
}
</style>
